import React from "react";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { Grid, makeStyles, useMediaQuery } from "@material-ui/core";

import CreateUserForm from "./CreateUserForm";
import userActions from "components/User/actions";
import InviteEmailLinkForm from "./InviteEmailLinkForm";
import { InviteType } from "../constants";
import { DialogContent, DialogTitle } from "components/common/DialogApi";
import Transition from "components/common/Transition";

const useStyles = makeStyles((theme) => ({}));

const InviteUserDialog = () => {
  const classes = useStyles();
  const { isCreateDialogOpen, inviteType } = useSelector((state) => state.user);
  const { closeCreateDialog, setInviteType } = userActions();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Dialog
      fullScreen={!matches}
      TransitionComponent={Transition}
      fullWidth
      disableBackdropClick
      open={isCreateDialogOpen}
      onClose={closeCreateDialog}
    >
      <DialogTitle onClose={closeCreateDialog}>
        Invite people to CuRVE
      </DialogTitle>
      <DialogContent className={classes.root}>
        <Grid container direction="row" justify="space-around">
          <Button
            variant={inviteType === InviteType.EMAIL ? "contained" : "outlined"}
            color={inviteType === InviteType.EMAIL ? "primary" : "secondary"}
            onClick={() => {
              setInviteType(InviteType.EMAIL);
            }}
          >
            Invite with email
          </Button>
          <Button
            variant={inviteType === InviteType.LINK ? "contained" : "outlined"}
            color={inviteType === InviteType.LINK ? "primary" : "secondary"}
            onClick={() => {
              setInviteType(InviteType.LINK);
            }}
          >
            Invite with link
          </Button>
          <Button
            variant={
              inviteType === InviteType.CREATE ? "contained" : "outlined"
            }
            color={inviteType === InviteType.CREATE ? "primary" : "secondary"}
            onClick={() => setInviteType(InviteType.CREATE)}
          >
            Create User
          </Button>
        </Grid>
        {inviteType === InviteType.CREATE && <CreateUserForm />}
        {(inviteType === InviteType.EMAIL ||
          inviteType === InviteType.LINK) && <InviteEmailLinkForm />}
      </DialogContent>
    </Dialog>
  );
};

export default InviteUserDialog;
